import { urlRoutes } from "../constants/page";

const closedStatuses = [
  "completed",
  "complete",
  "done",
  "closed",
  "approved",
  "rejected",
];

export function isOpenSubmitTask(task) {
  if (!task?.uuid || !task.taskFormUUID || Number(task.type) !== 1) {
    return false;
  }
  if (task.taskFormSubmissionUUID || task.completedAt) return false;
  return !closedStatuses.includes(String(task.status || "").toLowerCase());
}

export function openTask(task, navigate) {
  if (!task) return;

  if (isOpenSubmitTask(task)) {
    const params = new URLSearchParams({
      form: task.taskFormUUID,
      taskUUID: task.uuid,
    });
    if (task.assetUUID) params.set("asset", task.assetUUID);
    navigate(`${urlRoutes.form}?${params.toString()}`);
    return;
  }

  if (task.formSubmitUUID) {
    navigate(`${urlRoutes.reportView}?report=${task.formSubmitUUID}`);
    return;
  }

  if (task.assetUUID) {
    navigate(`${urlRoutes.assets}?asset=${task.assetUUID}&tab=Tasks`);
  }
}
